<script lang="ts">
    import {onMount} from "svelte";
    import CopyTextButtonView from "../../../../../component/common/Value/CopyTextButtonView.svelte";
    import {UrlUtil} from "../../../../../lib/Common/Http/UrlUtil";
    import {BinaryTable} from "../../../../../lib/Table/BinaryTable";
    import HoverTipsView from "../../../../../component/common/Message/HoverTipsView.svelte";

    export let spaceUniqueId;
    export let appUniqueId;
    export let binary;

    $: title = (() => {
        if (binary == null) {
            return null;
        }
        const platformType = binary.platform_type;
        const platformTypeName = BinaryTable.PlatformType.map[platformType];
        const binaryName = binary.name;

        const title = `${platformTypeName} - ${binaryName}`;
        return title;
    })();
    $: url = (() => {
        if (spaceUniqueId == null) {
            return null;
        }
        if (appUniqueId == null) {
            return null;
        }
        if (binary == null) {
            return null;
        }
        const binaryUniqueId = binary.unique_id;
        const url = UrlUtil.createFullWebUrl(`/space/${spaceUniqueId}/app/${appUniqueId}/binary/${binaryUniqueId}`);
        return url;
    })();

    $: copyText = (() => {
        if (url == null) {
            return null;
        }
        if (title == null) {
            return null;
        }

        const copyText = `<a href="${url}">${title}</a>`;
        return copyText;
    })();

    $: copyTextForMarkup = (() => {
        if (url == null) {
            return null;
        }
        if (title == null) {
            return null;
        }

        const copyText = `[${title}](${url})`;
        return copyText;
    })();

    onMount(() => {
    });


</script>

{#if copyText != null}
    <div class="binary-link-copy-button-view">
        <div class="left-area">
            <div>
                <CopyTextButtonView
                        label="link copy" text={title} url={url}
                        fontAwesomeIcon="slack" fontAwesomeClassification="fab"
                />

            </div>
            <div>
                <CopyTextButtonView
                        label="link copy for markup" text={copyTextForMarkup}
                        fontAwesomeIcon="slack" fontAwesomeClassification="fab"
                />

            </div>
            <div>

            </div>
        </div>
        <div class="right-area">
            <HoverTipsView message="Slackの設定により使えるコピーボタンが違います。設定変更していない場合は「link copy」をご利用ください"/>
        </div>

    </div>
{/if}
<style lang="scss">
    .binary-link-copy-button-view {
        font-size: 0.5em;

        display: flex;
        align-items: center;
        gap: 4px;

        .left-area {
            display: flex;
            flex-direction: column;
            gap: 8px;

        }

        .right-area {

        }

    }
</style>